export class GdsgBigtableTableStorage {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "table",
            "baseName": "table",
            "type": "string",
            "format": ""
        },
        {
            "name": "bytesUsed",
            "baseName": "bytesUsed",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "storageTypes",
            "baseName": "storageTypes",
            "type": "Array<GdsgBigtableStorageTypeBytes>",
            "format": ""
        },
        {
            "name": "observedAtMs",
            "baseName": "observedAtMs",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return GdsgBigtableTableStorage.attributeTypeMap;
    }
    constructor() {
    }
}
